var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.728 17.748C29.8798 15.1666 29.243 12.6 27.9022 10.3889C26.5614 8.17775 24.58 6.42658 22.2208 5.36773C19.8617 4.30887 17.2363 3.99239 14.6931 4.46026C12.1499 4.92814 9.80905 6.15827 7.9812 7.98741C6.15335 9.81656 4.92489 12.1583 4.45881 14.7018C3.99274 17.2453 4.31109 19.8705 5.37162 22.2289C6.43215 24.5873 8.18472 26.5675 10.3968 27.9067C12.6089 29.2459 15.1759 29.8809 17.7572 29.7273M22.666 26.9167H31.166M26.916 22.6667V31.1667M12.7493 14.1667H12.7635M21.2493 14.1667H21.2635",
    stroke: "#548170",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.459 21.25C14.3912 22.1567 15.669 22.6667 17.0007 22.6667C18.3323 22.6667 19.6102 22.1567 20.5423 21.25",
    stroke: "#548170",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodIcon);
export default __webpack_public_path__ + "static/media/mood_icon.3f15adc0c0d02177b0e28f89eb6e5e04.svg";
export { ForwardRef as ReactComponent };